import type { ReactNode } from "react";
import { useState } from "react";

import UI from "./UI";

type UIProps = React.PropsWithChildren<{
  title: string;
  titleExtraComponent?: ReactNode;
  startOpen?: boolean;
}>;

const ProductAccordion = ({
  startOpen = false,
  title,
  children,
  titleExtraComponent,
}: UIProps) => {
  const [open, setOpen] = useState(startOpen);
  const toggle = () => setOpen(!open);
  return (
    <UI
      open={open}
      toggle={toggle}
      titleExtraComponent={titleExtraComponent}
      title={title}
    >
      {children}
    </UI>
  );
};

export default ProductAccordion;
